import { QuantityField } from 'components/Common/UnitEditor/QuantityField'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import React, { ForwardedRef, useImperativeHandle, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  QuantityDto,
  QuantityDtoType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { useAppSelector } from 'store/configureStore'
import { projectSelectors } from '../store/selectors/projectSelectors'

type Props = {
  bomItemPointer: BomItemPointer
  activityId: string
  onChange: (value: QuantityDto) => void
  disabled?: boolean
}

export type BomItemMaterialSurchargePercentageRef = {
  reset: () => void
}

export const BomItemMaterialSurchargePercentage = React.forwardRef(
  (props: Props, ref: ForwardedRef<BomItemMaterialSurchargePercentageRef>) => {
    const { t } = useTranslation()

    const bomItemSurcharge = useAppSelector(
      projectSelectors.bomItemMaterialFinancialSelector(
        props.bomItemPointer,
        props.activityId,
        'surchargeRatio',
      ),
    ) as QuantityDto

    const [surchargeRatio, setSurchargeRatio] = useState({
      value: bomItemSurcharge?.value || 0,
      unit: '%',
      quantityType: QuantityDtoType.Ratio,
    } as QuantityDto)

    const handleChange = (value: QuantityDto) => {
      setSurchargeRatio({
        value: value.value,
        unit: '%',
        quantityType: QuantityDtoType.Ratio,
      })

      props.onChange(value)
    }

    useImperativeHandle(ref, () => ({
      reset: () => {
        setSurchargeRatio({
          value: bomItemSurcharge?.value || 0,
          unit: '%',
          quantityType: QuantityDtoType.Ratio,
        })
      },
    }))

    return (
      <QuantityField
        name="surchargeRatio"
        label={`${t('common:surcharge')}`}
        value={surchargeRatio}
        onChange={(value) => handleChange(value as QuantityDto)}
        disabled={props.disabled}
      />
    )
  },
)
